module.exports = __webpack_public_path__ + "img/971.6bb1933c.gif";